import { useEffect } from 'react';
import { Shipper } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useShipper() {
  const shipper = useAxios(
    (axios, signal) =>
      axios.request<Shipper>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipper.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipper;
}

export type ShipperRequest = ReturnType<typeof useShipper>;
